import { Injectable } from '@angular/core';
import { parseISO, format, parse, formatISO } from 'date-fns';
import * as moment from 'moment';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateUtilsService {
  constructor() {}

  formatDateToISO(value: any) {
    if (value) {
      value = value.substring(0, 10);
      const date = parse(value, 'dd/MM/yyyy', new Date());
      return date.toJSON();
    }
    return value;
  }

  formatStringToISO8601(value: string) {
    if (!value) {
      return '';
    }
    value = value.substring(0, 10);
    const date = parse(value, 'dd/MM/yyyy', new Date());
    const dateMoment = moment(date);
    return this.fromMomentObjToISO8601(dateMoment);
  }

  formatISOToDate(isoDate: string) {
    if (!isoDate) {
      return '';
    }
    const date = parseISO(isoDate);
    return format(date, 'dd/MM/yyyy');
  }

  formatDateToReadable(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };

    return new Intl.DateTimeFormat('pt-BR', options).format(date);
  }

  formatISOToDateHour(dateString: string): string {
    const date = new Date(dateString);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const year = String(date.getFullYear()).slice(-2); // Pegando apenas os dois últimos dígitos do ano
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  isValidDateString(dateStr: string): boolean {
    //If user empties the input
    if (dateStr === '' || dateStr === null) {
      return true;
    }

    // Ensure the date string has a valid year (at least 4 digits)
    const yearMatch = dateStr.match(/(\d{4})/);
    if (!yearMatch) {
      return false;
    }

    // Check with Date
    const dateObj = new Date(dateStr);
    if (!isNaN(dateObj.getTime())) {
      return true;
    }

    // Check with moment
    const momentObj = moment(dateStr, moment.ISO_8601, true);
    return momentObj.isValid();
  }

  formatDateToISO8601(date: Date | Moment) {
    if (!date) {
      return '';
    }

    if (date instanceof Date) {
      return this.fromDateObjToISO8601(date);
    }

    if (moment.isMoment(date)) {
      return this.fromMomentObjToISO8601(date);
    }

    return date;
  }

  private fromDateObjToISO8601(date: Date) {
    const dateMoment = moment(date);
    return this.fromMomentObjToISO8601(dateMoment);
  }

  private fromMomentObjToISO8601(date: Moment) {
    date = date.utc();
    const day = date.date().toString().padStart(2, '0');
    const month = (date.month() + 1).toString().padStart(2, '0');
    const year = date.year().toString();
    return `${year}-${month}-${day}`;
  }
}
